const isStoreIdentifierValid = (webStoreVo) => {
  const { identifier } = webStoreVo || {};
  const isValid = /^\d{8}$/.test(identifier);
  return isValid;
};

export default isStoreIdentifierValid;
